'use strict';

/**
 * Sticky "Sign up / Login" badge (DoT Upgrades).
 *
 * Replaces the login button that used to sit in the header. Shown only to
 * logged-out visitors. The markup lives in the `sticky-signup-badge` content
 * asset, so it carries no environment-specific URL - the href is taken from
 * the hidden input rendered by the (remote-included) account/avatar template.
 */
module.exports = function () {
    var $badge = $('.js-signup-badge');

    if (!$badge.length) {
        return;
    }

    if ($('#isUserLoggedIn').val() === 'true') {
        $badge.remove();
        return;
    }

    var loginUrl = $('#loginRegisterUrl').val();

    if (loginUrl) {
        $badge.attr('href', loginUrl);
    }

    $badge.addClass('is-visible');
    // Lets the footer reserve room so the fixed badge doesn't sit on top of
    // page content when scrolled to the bottom.
    $('body').addClass('has-signup-badge');
};
